import React from 'react'

import { Navigation, NavigationButton } from './styled'

export default function AnalyticsNavigation({ section, sections = [], onSelect, t }) {
  return (
    <Navigation aria-label={t('analytics_navigation_label')}>
      {sections.map(item => (
        <NavigationButton
          active={section === item}
          aria-current={section === item ? 'page' : undefined}
          key={item}
          onClick={() => onSelect(item)}
          type="button"
        >
          {t(`analytics_nav_${item}`)}
        </NavigationButton>
      ))}
    </Navigation>
  )
}
